/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react';
import { twMerge } from 'tailwind-merge';

import Typography from '../typography';

export interface ISwatch {
  class: string;
  id: string;
  color: string;
}
interface IProps {
  swatchConfig: { [key: string]: ISwatch };
  active: ISwatch | undefined;
  onClick: (swatch: ISwatch) => void;
  label: string;
}

const ColorSwatches = ({ active, label, onClick, swatchConfig }: IProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Typography className="text-gray-70" variant="body2">
        {label}
      </Typography>
      <div className="flex w-full flex-wrap gap-2">
        {Object.values(swatchConfig).map((swatch) => (
          // eslint-disable-next-line jsx-a11y/control-has-associated-label
          <button
            key={swatch.id}
            className={twMerge(
              'h-5 w-5 px-0 py-0',
              swatch.class,
              active?.id === swatch.id &&
                'outline outline-2 outline-offset-[1px] outline-blue-60'
            )}
            type="button"
            onClick={() => onClick(swatch)}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorSwatches;
